export default __webpack_public_path__ + "static/perfect-design-process_24-8e70f021ac5f709808791acee1f26832.png";